const state = {
    employee: [],
    subordinate: [],
    loading: false
};

export default state;